import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { TalukService } from '../taluk.service'
import { FormControl } from '@angular/forms';


@Component({
  selector: 'app-taluk-table',
  templateUrl: './taluk-table.component.html',
  styleUrls: ['./taluk-table.component.scss']
})
export class TalukTableComponent implements OnInit {
  nameFilter = new FormControl('');
  filterValues = {
    id: '',
    name: '',
  };
  dataSource: any;
  displayedColumns: string[] = ['id', 'name', 'district_name'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private global: GlobalService, private http : HttpService, public service: TalukService) {
    this.global.set_master_page_title = 'Taluk';
    this.getTaluk();
    this.service.downloadTaluk.subscribe((taluk) => {
      console.log(taluk);
      if (taluk) {
        this.getTaluk();
      }
    });
   }

  getTaluk() {
    this.http.getTaluks().subscribe((data: Taluk[]) => {
      console.log(data);
      this.dataSource = new MatTableDataSource<Taluk>(data);
      this.dataSource.sort = this.sort;
      this.dataSource.data = data;
      this.dataSource.filterPredicate = this.createFilter();
    }, (error) => {
      console.log(error);
    });
  }

  registerTaluk() {
    this.showTalukRegister();
    this.service.TalukUpdate.emit(null);
    this.service.set_taluk_data = null;
  }

  editTaluk(element) {
    this.showTalukRegister();
    this.service.TalukUpdate.emit(element);
    this.service.set_taluk_data = element;
  }

  hideTalukRegister() {
    this.service.is_display_taluk_register_component = false;
  }

  showTalukRegister() {
    this.service.is_display_taluk_register_component = true;
  }


 
  ngOnInit() {
    console.log('ng funct');
    this.nameFilter.valueChanges
      .subscribe(
        name => {
          this.filterValues.name = name;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
  }

  createFilter():
  (data: any, filter: string) => boolean {
  console.log('filter')
  let filterFunction = function (data, filter): boolean {
    let searchTerms = JSON.parse(filter);
    return data.name.toString().toLowerCase().indexOf(searchTerms.name.toString().toLowerCase()) !== -1
  }
  return filterFunction;
}


}

export interface Taluk {
  id: number;
  name: string;
}